import { Link } from 'react-router-dom';



const Order = (): JSX.Element => {

	return (
		<div className='footer-menu order-section'>

			<Link to={'https://vetlimce.blob.core.windows.net/vcz/VETlimce_obchodni_podminky_spotrebitel_Skretova.pdf'} className='disable-selection' target='_blank'>
				Obchodní podmínky pro spotřebitele
			</Link>

			{/*<Link to={NavigateRoutesEnum.basePath} className='disable-selection'>
				Všeobecné obchodní podmínky pro podnikatele
			</Link>*/}

			<Link to={'https://vetlimce.blob.core.windows.net/vcz/VETlimce_informace-GDPR_V1.0_Skretova.pdf'} className='disable-selection' target='_blank'>
				Ochrana osobních údajů
			</Link>

			<Link to={'https://vetlimce.blob.core.windows.net/vcz/VETlimce_sdeleni_pred_uzavrenim_smlouvy_2023_V1_3.pdf'} className='disable-selection' target='_blank'>
				Sdělení před uzavřením smlouvy
			</Link>

			<Link to={'https://vetlimce.blob.core.windows.net/vcz/REKLAMACNI-FORMULAR.pdf'} className='disable-selection' target='_blank'>
				Reklamační formulář
			</Link>

			<Link to={'https://vetlimce.blob.core.windows.net/vcz/VETlimce_formular_odstoupeni_2023_V1.2.pdf'} className='disable-selection' target='_blank'>
				Formulář pro odstoupení
			</Link>

			{/*<Link to={NavigateRoutesEnum.basePath} className='disable-selection'>
				Dodací a platební podmínky
			</Link>*/}
			
		</div>
	);
}

export default Order;